import React from 'react';
import { useTranslation } from '@lib/useTypedTranslation';

import { ALERT } from '@components/alertsPanel/alertMessages';
import { SmartBatteryAlertStatus, smartBatteryAlertStatuses } from '../../../services/config/alertConstants';
import { BatteryAlertText } from '../../../containers/batteryOverview/composition/alertsOverview';

import { FilterFormProps } from './popoverDialog';
import { BaseAlertsFilter } from './baseAlertsFilter';

export const getSmartBatteryAlertStatusFilterId = (status: SmartBatteryAlertStatus, alert: ALERT): string => `${status}-${alert}`;

export const getSmartBatteryAlertStatusFromFilterId = (id: string): SmartBatteryAlertStatus => id.split('-')[0] as SmartBatteryAlertStatus;

export const BatteryAlertsFilter: React.FC<FilterFormProps> = ({ close }) => {
  const { t } = useTranslation(['translation', 'filters', 'batteryOverview', 'batteryEssentials']);

  const batteryAlertNames: BatteryAlertText = {
    batteryHealthStatus: t('HEALTH', { ns: 'batteryEssentials' }),
    batteryAverageDischargeStatus: t('AVERAGE_DISCHARGE', { ns: 'translation' }),
    batteryCycleCountStatus: t('CYCLE_COUNT', { ns: 'batteryEssentials' })
  };

  const alertConfig = {
    alertTypes: smartBatteryAlertStatuses,
    alertNames: batteryAlertNames,
    getFilterId: getSmartBatteryAlertStatusFilterId,
    getAvailableLevels: () => [ALERT.red, ALERT.yellow, ALERT.green],
    statusHeaderLabel: t('BATTERY_STATUS_HEADER', { ns: 'batteryEssentials' })
  };

  return <BaseAlertsFilter close={close} alertConfig={alertConfig} className="alerts-filter--battery" />;
};
